<template>
<modal :show="show" @close="close">
    <div class="modal-header">
        <h5 class="modal-title">{{title}}</h5>
        <button @click="close" type="button" class="close btn btn-round">
            <i class="icon icon-close"></i>
        </button>
    </div>

    <div class="modal-body">
        {{message}}
    </div>

    <div class="modal-footer">
		<slot :cancel="cancel" :confirm="confirm">
			<button @click="cancel">
				{{cancelText}}
			</button>
			<button class="confirm-button" @click="confirm">
				{{confirmText}}
			</button>
		</slot>
    </div>
</modal>
</template>

<script>
import Modal from "@/../submodules/vue-base/components/Modal";
export default {

    name: 'ConfirmModal',

    props: {
        title: '',
        message: '',
        confirmText: {
            type: String,
            default: "Confirm"
        },
        cancelText: {
            type: String,
            default: "Cancel"
        },
    },

    components: {
        Modal
    },

    data() {
        return {
            show: false
        }
    },

    methods: {
        open() {
            this.show = true;
        },

        close() {
            this.show = false;
            this.$emit('close');
        },

		cancel(){
			this.close();
			this.$emit('cancel');
		},

        confirm() {
            this.show = false;
            this.$emit('confirm');
        }
    }

}
</script>
